import { useQueryClient } from '@tanstack/react-query';
import { jobServices } from '../services/job.service';

export const usePrefetchJobs = () => {
  const queryClient = useQueryClient();

  const prefetchJobs = (params) => {
    queryClient.prefetchQuery({
      queryKey: ['jobs', params],
      queryFn: () => jobServices.getJobs(params),
      staleTime: 5 * 60 * 1000,
    });
  };

  const prefetchNextPage = (currentParams, totalPages) => {
    const currentPage = parseInt(currentParams.page);
    if (currentPage < totalPages) {
      prefetchJobs({ ...currentParams, page: String(currentPage + 1) });
    }
  };

  const prefetchPrevPage = (currentParams) => {
    const currentPage = parseInt(currentParams.page);
    if (currentPage > 1) {
      prefetchJobs({ ...currentParams, page: String(currentPage - 1) });
    }
  };

  return { prefetchJobs, prefetchNextPage, prefetchPrevPage };
};
